import { doordashAuthenticator, woltAuthenticator } from './authenticators';
import { organization } from './organization';

export const authenticator = organization === 'wolt' ? woltAuthenticator : doordashAuthenticator;
